let EpisodeDrgAuditTypeService = function ($http, $q, $rootScope) {

    var auditTypeOptions = {};

    let types = function () {
        var deferred = $q.defer();
        if (!auditTypeOptions.Promise) {
            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
            auditTypeOptions = $http.get(WEBSERVICEURL + '/dataagility/api/service.drgaudittype')
                .then(function successCallback(response) {
                    auditTypeOptions = response.data;
                    deferred.resolve(auditTypeOptions);
                },
                function errorCallback(response) {
                  if (response.status === 401) {
                    window.location.replace(window.location.origin + '/login?logout=true');
                  }
                });
        } else {
            deferred.resolve(auditTypeOptions);
        }
        return deferred.promise;
    }

    return { types };
};

export default EpisodeDrgAuditTypeService;



// WEBPACK FOOTER //
// ./client/app/common/services/episodeDrgAuditType.service.js